/* eslint-disable react/jsx-props-no-spreading -- we need this
to pass aria props to non mobile button */
import React from 'react';
import PropTypes from 'prop-types';
import { OnVisible } from '@americanexpress/data-manager-utils';
import { Button } from '@americanexpress/dls-react';

const TravelCreditTabButton = ({
  buttonLabel,
  onClick,
  analyticsInfo,
  ...otherProps
}) => (
  <OnVisible analyticsInfo={analyticsInfo}>
    <Button
      onClick={onClick}
      reactlytics={analyticsInfo}
      variant="secondary"
      {...otherProps}
    >
      {buttonLabel}
    </Button>
  </OnVisible>
);

TravelCreditTabButton.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  analyticsInfo: PropTypes.shape({
    element: PropTypes.string,
    detail: PropTypes.string,
  }).isRequired,
};

export default TravelCreditTabButton;
/* eslint-enable react/jsx-props-no-spreading -- we need this
to pass aria props to non mobile button */
